import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { cloneDeep } from 'lodash';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { UserServiceModal, PersonalInfo, WebOffice } from 'src/app/modals/userservice.modal';
import { RestApiService } from './restapi.service';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class UserService  {
  // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
  // Add 'implements OnInit' to the class.
  isLoggedIn: Observable<boolean>;
  public userServiceModal: UserServiceModal;
  public userServiceSubject: BehaviorSubject<UserServiceModal>;
  public userServiceSubscriber: Subscriber<UserServiceModal>;
  constructor(
    public activatedRoute: ActivatedRoute,
    public apiService: RestApiService,
    public utilityService: UtilityService,
    public cookieService: CookieService
    ) {
    this.userServiceModal = new UserServiceModal();
    this.isLoggedIn = this.apiService.isLoggedIn();
    this.isLoggedIn.subscribe((data) => {
    });

  }
  public service: any = {};

  /** * init * @method  init */
  public init(): void {
    if (localStorage.getItem('userService')) {
      this.service = JSON.parse(localStorage.getItem('userService')) as UserServiceModal;
      this.userServiceModal.customerTypeID = parseInt(this.activatedRoute.snapshot.queryParams.type, 10) || this.service.customerTypeID || 2;
      this.userServiceModal.enrollerInfo = this.service.enrollerInfo || {
        FirstName: '',
        LastName: '',
        ImageUrl: '',
        EmailAddress: ''
      };
      this.userServiceModal.guestUserLogin = this.service.guestUserLogin || false;
      this.userServiceModal.customerData = this.service.customerData || {
        FirstName: '',
        LastName: '',
        ImageUrl: '',
        EmailAddress: ''
      };
      this.userServiceModal.guestUserData = this.service.guestUserData || {};
      this.userServiceModal.shippingAddress = this.service.shippingAddress || {};
      this.userServiceModal.mailingAddress = this.service.mailingAddress || {};
      this.userServiceModal.newshippingAddress = this.service.newshippingAddress || {};
      this.userServiceModal.personalInfo = this.service.personalInfo || {} as PersonalInfo;
      this.userServiceModal.personalInfo.birthDay = this.service.personalInfo.birthDay || '01';
      this.userServiceModal.personalInfo.birthMonth = this.service.personalInfo.birthMonth || '01';
      this.userServiceModal.personalInfo.birthYear = this.service.personalInfo.birthYear || (moment().year() - 18).toString();
      this.userServiceModal.personalInfo.phoneNumber = this.service.personalInfo.phoneNumber || {};
      this.userServiceModal.webOffice = this.service.webOffice || {};
      this.userServiceModal.couponInfo = this.service.couponInfo || {
        IsAppliedcode: false,
        promoCodeValid: false,
        promoCode: '',
        Allcoupons: [],
        RewardsForUse: [],
        FreeShipping: {
          activated: false,
          coupon: ''
        },
        availableRewards: [],
        OrderAllowCoupons: []
      };
      this.userServiceModal.DynamicCouponCode = this.service.DynamicCouponCode || {};
      this.userServiceModal.couponInfo.IsAppliedcode = this.service.couponInfo?.IsAppliedcode || false;
      this.userServiceModal.paymentMethods = this.service.paymentMethods || [];
      this.userServiceModal.referralURL = this.activatedRoute.snapshot.queryParams.ref;
      this.userServiceModal.restrictedStates = this.service.restrictedStates || [];
      this.userServiceModal.restrictedShipStates = this.service.restrictedShipStates || '';
      this.userServiceModal.selectedShippingMethod = this.service.selectedShippingMethod || "";
      this.userServiceModal.shippingMethods = this.service.shippingMethods || [];
      this.userServiceModal.autoshipCardDetail = this.service.autoshipCardDetail || {};
      this.userServiceModal.cardDetail = this.service.cardDetail || {};
      this.userServiceModal.commissionPayment = this.service.commissionPayment || '';
      this.userServiceModal.licenseNumber = this.service.licenseNumber || '';
      this.userServiceModal.legName = this.activatedRoute.snapshot.queryParams.legName;
      this.userServiceModal.enrollerId = Number(this.activatedRoute.snapshot.queryParams.enrollerId || this.service.enrollerId) || 0;
      this.userServiceModal.sponsorId = Number(this.activatedRoute.snapshot.queryParams.sponsorId || this.service.sponsorId) || 0;
      this.userServiceModal.doNotWishAutoship = this.service.doNotWishAutoship || false;
      this.userServiceModal.checkItems = this.service.checkItems || false;
      this.userServiceModal.autologin = this.service.autologin || this.activatedRoute.snapshot.queryParams.autologin || false;
      this.userServiceModal.regionMainState = this.service.regionMainState || '';
      this.userServiceModal.newUser = this.service.newUser || false;
      this.userServiceModal.TotalSteps = 6;
      this.userServiceModal.noOfStepsVerified = this.service.noOfStepsVerified || 0;
      this.userServiceModal.couponInfo.availableRewards = this.service?.couponInfo?.availableRewards || [];
      this.userServiceModal.WebAlias = this.service.WebAlias || this.service.customerData?.WebAlias || 'www';
      // this.userServiceModal.selectedLanguageCode = this.activatedRoute.snapshot.queryParams.LanguageCode || this.service.selectedLanguageCode || 'en';
      // this.userServiceModal.selectedCountry = this.userServiceModal.selectedCountry || this.activatedRoute.snapshot.queryParams.countrycode || 'US';
    } else {
      this.setDefault();
    }
  }

  /*** clear Data of application * @method  clearData ***/
  public clearData() {
    localStorage.removeItem('userService');
    this.service = {};
    this.init();
  }

  public clearCustomerData() {
    this.userServiceModal.customerData = {
      FirstName: '',
      LastName: '',
      ImageUrl: '',
      EmailAddress: ''
    };
  }

  public setEnrollerInfo(websiteinfo){
    this.userServiceModal.enrollerInfo = websiteinfo;
    localStorage.setItem('userService', JSON.stringify(this.userServiceModal));
  }
  /** * Set Default * @method  setDefault */
  public setDefault() {
    this.userServiceModal.customerTypeID = parseInt(this.activatedRoute.snapshot.queryParams.type, 10) || this.service.customerTypeID || 2;
    this.userServiceModal.enrollerInfo = {
      FirstName: '',
      LastName: '',
      ImageUrl: '',
      EmailAddress: ''
    };
    this.userServiceModal.guestUserLogin = false;
    this.userServiceModal.shippingAddress = null;
    this.userServiceModal.mailingAddress = {};
    this.userServiceModal.newshippingAddress = {};
    this.userServiceModal.personalInfo = {
      birthDay: 1,
      birthMonth: 1,
      birthYear: Number((moment().year() - 18).toString()),
      phoneNumber: '',
      Email: ''
    };
    this.userServiceModal.webOffice = {} as WebOffice;
    this.userServiceModal.paymentMethods = [];
    this.userServiceModal.referralURL = this.activatedRoute.snapshot.queryParams.ref;
    this.userServiceModal.autoshipCardDetail = {};
    this.userServiceModal.cardDetail = {
      CardExpirationYear: new Date().getFullYear(),
      CardExpirationMonth: (new Date().getMonth() + 1),
      CardNumber: ''
    };
    this.userServiceModal.customerData = {};
    this.userServiceModal.commissionPayment = '';
    this.userServiceModal.licenseNumber = '';
    this.userServiceModal.legName = this.activatedRoute.snapshot.queryParams.legName;
    this.userServiceModal.enrollerId = Number(this.activatedRoute.snapshot.queryParams.enrollerId) || 0;
    this.userServiceModal.sponsorId = Number(this.activatedRoute.snapshot.queryParams.sponsorId) || 0;
    this.userServiceModal.doNotWishAutoship = false;
    this.userServiceModal.defaultState = '';
    this.userServiceModal.couponInfo = {
      IsAppliedcode: false,
      promoCodeValid: undefined,
      promoCode: '',
      Allcoupons: [],
      RewardsForUse: [],
      FreeShipping: {
        activated: false,
        coupon: undefined
      },
      availableRewards: [],
      OrderAllowCoupons: []
    };
    // this.userServiceModal.autoshipDate = moment().add(1, 'months').toDate();
    // this.userServiceModal.customerData = {
    //   FirstName: '',
    //   LastName: '',
    //   ImageUrl: '',
    //   EmailAddress: ''
    // };
    this.userServiceModal.guestUserData = {};
    this.userServiceModal.restrictedShipStates = '';
    this.userServiceModal.restrictedStates = [];
    this.userServiceModal.selectedShippingMethod = "";
    this.userServiceModal.shippingMethods = [];
    this.userServiceModal.checkItems = false;
    this.userServiceModal.autologin = this.activatedRoute.snapshot.queryParams.autologin || false;
    this.userServiceModal.regionMainState = '';
    this.userServiceModal.newUser = false;
    this.userServiceModal.TotalSteps = 6;
    this.userServiceModal.noOfStepsVerified = 0;
    this.userServiceModal.WebAlias = this.userServiceModal.WebAlias || this.userServiceModal.customerData?.WebAlias || 'www';
    localStorage.setItem('userService', JSON.stringify(this.userServiceModal));
  }

  /**
   * set user shipping address
   * @method  setShippingAddress
   */
  public setShippingAddress() {
      const customerData = this.userServiceModal.customerData;
      const defaultAddr = customerData ? customerData.DefaultShippingAddress : null;
      this.userServiceModal.shippingAddress = this.userServiceModal.shippingAddress || cloneDeep(defaultAddr);
      if (!this.userServiceModal.shippingAddress) {
          return;
      }
      const addr = this.userServiceModal.shippingAddress;
      addr.FullName = (addr.FirstName || (customerData ? customerData.FirstName : '') || '') + ' ' + (addr.LastName || (customerData ? customerData.LastName : '') || '');
      addr.FirstName = addr.FirstName || (customerData ? customerData.FirstName : '') || '';
      addr.LastName = addr.LastName || (customerData ? customerData.LastName : '') || '';
      addr.Street1 = addr.Street1 || (!this.utilityService.isEmptyObject(defaultAddr) ? defaultAddr.Street1 : '') || '';
      addr.Street2 = addr.Street2 || (!this.utilityService.isEmptyObject(defaultAddr) ? defaultAddr.Street2 : '') || '';
      addr.Street3 = addr.Street3 || (!this.utilityService.isEmptyObject(defaultAddr) ? defaultAddr.Street3 : '') || '';
      addr.Region = addr.Region || (!this.utilityService.isEmptyObject(defaultAddr) ? defaultAddr.Region : '') || '';
      addr.PostalCode = addr.PostalCode || (!this.utilityService.isEmptyObject(defaultAddr) ? defaultAddr.PostalCode : '') || '';
      addr.CountryCode = addr.CountryCode || (!this.utilityService.isEmptyObject(defaultAddr) ? defaultAddr.CountryCode : '') || '';
      addr.City = addr.City || (!this.utilityService.isEmptyObject(defaultAddr) ? defaultAddr.City : '') || '';
      addr.Phone = addr.Phone || (!this.utilityService.isEmptyObject(defaultAddr) ? defaultAddr.Phone : '') || '';
  }

  // Check if User is Authenticated Or not
  public checkIfUserAuthenticatedOrNot():boolean {
      return this.cookieService.check('X-Auth');
  }
}
